import React from 'react';
import {
  Container,
  RemittanceText,
  IconComp,
  LinkText,
  TextContainer,
} from './styles';
import RequestRemittance from '../../../assets/icons/RequestRemittance.svg';
import RequestWhite from '../../../assets/icons/RequestWhite.svg';
import {theme} from '../../../styles/darkTheme';
import {useTranslation} from '../../../context/language';
import {SEND_REMITTANCE} from '../../../utils/constants';

interface Props {
  isCurrentUser?: boolean;
  amount: string;
  convertedAmount?: string;
  id?: string;
  reason?: string;
  type: string;
  onClick?: () => any;
}

const RemittanceAttachment: React.FC<Props> = ({
  isCurrentUser,
  amount,
  convertedAmount = '',
  id = '',
  type,
  reason = '',
  onClick,
}) => {
  const {text} = useTranslation();
  const data = {
    icon: type === SEND_REMITTANCE ? RequestRemittance : RequestRemittance,
    text:
      type === SEND_REMITTANCE
        ? text.sendRemittanceAttachment(id, amount, convertedAmount)
        : text.requestRemittanceAttachment(amount, reason),
  };
  return (
    <Container>
      <IconComp src={data.icon} size={type === SEND_REMITTANCE ? 35 : 35} />
      <TextContainer>
        <RemittanceText theme={theme} isCurrentUser={isCurrentUser}>
          {data.text}
        </RemittanceText>
        <LinkText theme={theme} isCurrentUser={isCurrentUser} onClick={onClick}>
          {text.showDetails}
        </LinkText>
      </TextContainer>
    </Container>
  );
};

export default RemittanceAttachment;
